import { useCallback, useEffect, useState } from "react";


export function useUrlParam<T>(
  paramName: string,
  serialize: (value: T) => string | null,
  deserialize: (value: string | null) => T,
): [T, (value: T) => void, (value: T) => void] {
  const [value, setValue] = useState(deserialize(new URLSearchParams(window.location.search).get(paramName)));

  const setParam = useCallback((newValue: T) => {
    const params = new URLSearchParams(window.location.search);
    let serializedValue = serialize(newValue);
    if (serializedValue === null) {
      params.delete(paramName);
    } else {
      params.set(paramName, serializedValue);
    }
    const variables = params.toString() ? `?${params.toString()}` : '';
    window.history.pushState(
      {},
      "",
      `${window.location.pathname}${variables}`
    );
    setValue(deserialize(serializedValue));
  }, [paramName, serialize, deserialize]);


  // Listen for popstate to update value if user navigates browser history
  useEffect(() => {
    const onPopState = () => {
      const params = new URLSearchParams(window.location.search);
      const v = params.get(paramName);
      setValue(deserialize(v));
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [paramName, deserialize]);

  return [value, setParam, setValue];
}
